package org.matthewo

import js.coroutines.awaitCancellation
import react.useEffect
import react.useMemo
import web.dom.ElementId
import web.dom.document

private var idx = 0
private val pagesLoading = mutableMapOf<Int, Boolean>()

fun useLoading(loading: Boolean) {
    val i = useMemo {
        val i = idx
        idx++
        i
    }
    useEffect(i, loading) {
        pagesLoading[i] = loading
        updateLoading()
        awaitCancellation {
            pagesLoading -= i
            updateLoading()
        }
    }
}

private fun updateLoading() {
    val loading = pagesLoading.values.any { it }
    document.getElementById(ElementId("load"))?.style?.display = if (loading) "" else "none"
}
